import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    user: JSON.parse(
        localStorage.getItem('chat-app-user')
    ),
    onlineUsers: []
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            localStorage.setItem('chat-app-user', JSON.stringify(action.payload.user))
            state.user = action.payload.user
        },
        removeUser: (state) => {
            state.user = null
            state.onlineUsers = [];
            localStorage.clear();
        },
        setOnlineUsers: (state, action) => {
            state.onlineUsers = action.payload;
        }
    },
})

export const { removeUser, setUser, setOnlineUsers } = userSlice.actions

export default userSlice.reducer